import { CorporateHolderModel, IndividualHolderModel } from "@models/shares/security-registry-record";
import { ClientSecurityTransaction } from "@models/security-transactions/client-security-transaction";

export class ShareGroupView {
  shareClass: string | null;
  shareType: string | null;
  shareholderName: string | null;
  shareholders: (IndividualHolderModel | CorporateHolderModel)[];
  numberOfShares: number;
  paidAmount: number;
  unpaidAmount: number;

  nonAsic: boolean;
  hasIssue: boolean;
  hasWarning: boolean;
  issueMessage: string | null;
  numberOfSharesAsic: number | null;
  paidAmountAsic: number | null;
  unpaidAmountAsic: number | null;
  callRecords: ClientSecurityTransaction[];

  // group by options
  hash: string;
  hashWithType: string;
  hashWithClass: string;

  constructor(data: Partial<ShareGroupView> = {}) {
    this.shareClass = data.shareClass ?? null;
    this.shareType = data.shareType ?? null;
    this.shareholderName = data.shareholderName ?? data.shareholders?.map((holder) => holder.name).join(', ') ?? '';
    this.shareholders = data.shareholders ?? [];
    this.numberOfShares = data.numberOfShares ?? 0;
    this.paidAmount = data.paidAmount ?? 0;
    this.unpaidAmount = data.unpaidAmount ?? 0;

    this.nonAsic = data.nonAsic ?? false;
    this.numberOfSharesAsic = data.numberOfSharesAsic ?? null;
    this.paidAmountAsic = data.paidAmountAsic ?? null;
    this.unpaidAmountAsic = data.unpaidAmountAsic ?? null;
    this.callRecords = data.callRecords ?? [];

    this.hasIssue = data.hasIssue ?? this.checkHasIssue();
    this.hasWarning = data.hasWarning ?? this.checkHasWarning();
    this.issueMessage = data.issueMessage ?? this.getIssueMessage();

    // group by options
    this.hash = data.hash ?? '';
    this.hashWithType = data.hashWithType ?? '';
    this.hashWithClass = data.hashWithClass ?? '';
  }

  checkHasIssue(outerRule = true): boolean {
    return outerRule
      && this.callRecords.length > 0
      && this.callRecords?.some((clientSecurityTransaction) => clientSecurityTransaction.isIncludeAlert);
  }

  checkHasWarning(outerRule = true): boolean {
    // has warning if
    // - related transactions are not empty
    // - the group include negative number of shares, paid amount or unpaid amount
    // - some of related transactions include negative number of shares, paid amount or unpaid amount
    // some of related transaction has SecurityHoldingValidationErrorMinusHistoricalBalance
    return outerRule
      && this.callRecords?.length > 0
      && (
        ((this.numberOfShares ?? 0) < 0 || (this.paidAmount ?? 0) < 0 || (this.unpaidAmount ?? 0) < 0)
        || this.callRecords?.some((clientSecurityTransaction) => clientSecurityTransaction.isIncludeWarning)
      );
  }

  getIssueMessage(hasIssue = this.hasIssue, hasWarning = this.hasWarning): string {
    if (hasIssue) return 'Negative current balance';
    if (hasWarning) return 'Negative historical balance';
    return '';
  }
}
